import React, { useEffect, useState } from "react";
import { useLocation, Link } from "react-router-dom";
import { useKeycloak } from "@react-keycloak/web";

//MUI components
import {
  Grid,
  Drawer,
  Typography,
  ClickAwayListener,
  Divider,
  MenuList,
  ListItemText,
  ListItemButton,
  IconButton,
  MenuItem,
  Menu,
} from "@mui/material";

//MUI icons
import ListItemIcon from "@mui/material/ListItemIcon";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import AccountBoxIcon from "@mui/icons-material/AccountBox";
import LogoutIcon from "@mui/icons-material/Logout";
import { styled } from "@mui/material/styles";

//components
import RandomlyColoredAvatar from "./RandomlyColoredAvatar";

//constants
import {
  MainMenu,
  SwiftMenu,
  SwiftRoutes,
  AlertsMenu,
  AlertsRoutes,
  MatchingMenu,
  MatchingRoutes,
  AdminToolMenu,
  AdminToolRoutes,
  //  UserManagementMenu,
  //  UserManagementRoutes,
  superAdminMenu,
} from "../../data";
import getMainMenu from "../../utils/permissions/getMainMenu";
import { useSelector } from "react-redux";
import { logoutHandler } from "../../utils/auth/logout";

const StyledMenu = styled((props) => (
  <Menu
    elevation={0}
    anchorOrigin={{
      vertical: "top",
      horizontal: "left",
    }}
    transformOrigin={{
      vertical: "top",
      horizontal: "right",
    }}
    {...props}
    sx={{ marginLeft: "230px" }}
  />
))(({ theme }) => ({
  "& .MuiPaper-root": {
    borderRadius: 6,
    minWidth: 210,
    color: "#050D2E",
    boxShadow:
      "rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px",
    "& .MuiMenu-list": {
      padding: "4px 0",
    },
    "& .MuiMenuItem-root": {
      color: "#050D2E",
      "&:active": {
        backgroundColor: "#D4EDF3",
      },
      "&:hover": {
        backgroundColor: "#D4EDF3",
      },
    },
  },
}));

const SideMenu = ({ sideMenuOpen, toggleSideMenu }) => {
  const { keycloak } = useKeycloak();
  const { isLocked } = useSelector((state) => state.licenseValidity);
  const { pathname } = useLocation();
  const [menuTitle, setMenuTitle] = useState("");
  const [mainMenu, setMainMenu] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const [nestedMenu, setNestedMenu] = useState([]);
  const [settingsDrawerOpen, setSettingsDrawerOpen] = useState(false);

  const open = Boolean(anchorEl);
  const handleAdminToolClick = (event) => {
    setAnchorEl(event.currentTarget);
    setNestedMenu(
      getMainMenu(
        keycloak.tokenParsed.canView || [],
        keycloak.tokenParsed.blocked || [],
        keycloak.hasRealmRole("bank-admin") ? "bank-admin" : "bank-user",
        AdminToolMenu
      )
    );
  };
  const handleUserManagementClick = (event) => {
    // setAnchorEl(event.currentTarget);
    // setNestedMenu(UserManagementMenu);
  };
  const handleCloseNestedMenu = () => {
    setAnchorEl(null);
  };

  const toggleSettingsDrawer = () => {
    setSettingsDrawerOpen(!settingsDrawerOpen);
  };

  useEffect(() => {
    let menu = [];
    if (keycloak.hasRealmRole("super-admin")) menu = superAdminMenu;
    else {
      if (SwiftRoutes.includes(pathname)) {
        menu = getMainMenu(
          keycloak.tokenParsed.canView || [],
          keycloak.tokenParsed.blocked || [],
          keycloak.hasRealmRole("bank-admin") ? "bank-admin" : "bank-user",
          SwiftMenu
        );
        setMenuTitle("SWIFT");
      } else if (AdminToolRoutes.includes(pathname)) {
        menu = getMainMenu(
          keycloak.tokenParsed.canView || [],
          keycloak.tokenParsed.blocked || [],
          keycloak.hasRealmRole("bank-admin") ? "bank-admin" : "bank-user",
          AdminToolMenu
        );
        setMenuTitle("Admin Tool");
      } else if (AlertsRoutes.includes(pathname)) {
        menu = getMainMenu(
          keycloak.tokenParsed.canView || [],
          keycloak.tokenParsed.blocked || [],
          keycloak.hasRealmRole("bank-admin") ? "bank-admin" : "bank-user",
          AlertsMenu
        );
        setMenuTitle("Alerts & Notifications");
      } else if (
        MatchingRoutes.includes(pathname) ||
        pathname.includes("rules")
      ) {
        menu = getMainMenu(
          keycloak.tokenParsed.canView || [],
          keycloak.tokenParsed.blocked || [],
          keycloak.hasRealmRole("bank-admin") ? "bank-admin" : "bank-user",
          MatchingMenu
        );
        setMenuTitle("Matching");
      } else {
        menu = getMainMenu(
          keycloak.tokenParsed.canView || [],
          keycloak.tokenParsed.blocked || [],
          keycloak.hasRealmRole("bank-admin") ? "bank-admin" : "bank-user",
          MainMenu
        );
      }
    }
    setMainMenu(menu);
  }, [keycloak, pathname]);

  // console.log(keycloak.tokenParsed);
  return (
    <>
      <IconButton
        sx={{
          background: "linear-gradient(180deg, #FFFFFF 0%, #F3F5F7 100%)",
          borderRadius: "50%",
          color: "#050D2E",
          border: "1px solid #CFD7DF",
          width: "24px",
          height: "24px",
          position: "fixed",
          left: sideMenuOpen ? "227px" : "54px",
          top: "65px",
          zIndex: "1300",
        }}
        variant="solid"
        onClick={toggleSideMenu}
        size="small"
      >
        {sideMenuOpen ? <KeyboardArrowLeftIcon /> : <KeyboardArrowRightIcon />}
      </IconButton>
      <Drawer
        variant="permanent"
        sx={{
          display: { xs: "none", sm: "block" },
          "& .MuiDrawer-paper": {
            boxSizing: "border-box",
            width: sideMenuOpen ? "240px" : "64px",
            marginTop: "48px",
            padding: "8px",
            background: "#FFFFFF",
            height: `${window.innerHeight - 48}px`,
          },
        }}
        open
      >
        {sideMenuOpen ? (
          <>
            {isLocked && !keycloak.hasRealmRole("super-admin") ? (
              <MenuList sx={{ width: "200px", padding: "8px" }}>
                <ListItemButton
                  sx={{
                    padding: "8px",
                    maxHeight: "32px",
                    height: "32px",
                    width: "216px",
                    "&:hover": { backgroundColor: "#D4EDF3" },
                    backgroundColor: "#D4EDF3",
                  }}
                >
                  <ListItemText
                    sx={{
                      color: "#1492AF",
                      "& .MuiTypography-root": {
                        fontWeight: 500,
                        fontSize: "14px",
                      },
                    }}
                  >
                    License
                  </ListItemText>
                </ListItemButton>
              </MenuList>
            ) : ["/", "/license", "/license/modules", "/reports"].includes(
                pathname
              ) || pathname.includes("reports") ? (
              <>
                <Grid container direction="column" sx={{ padding: "8px" }}>
                  <Typography
                    sx={{
                      fontSize: "12px",
                      lineHeight: "14px",
                      color: "#8792AB",
                      fontWeight: 500,
                    }}
                  >
                    MODULES
                  </Typography>
                  <MenuList sx={{ width: "216px" }}>
                    {mainMenu
                      .filter((item) => item.category === "modules")
                      ?.map((item) => {
                        return (
                          <Link
                            key={item.id}
                            to={item.path}
                            style={{ textDecoration: "none", color: "#050D2E" }}
                          >
                            <ListItemButton
                              sx={{
                                padding: "8px",
                                maxHeight: "32px",
                                height: "32px",
                                width: "216px",
                                "&:hover": { backgroundColor: "#D4EDF3" },
                                backgroundColor:
                                  pathname === item.path ? "#D4EDF3" : "#fffff",
                              }}
                            >
                              <ListItemIcon
                                sx={{
                                  width: "20px",
                                  minWidth: "20px",
                                  height: "20px",
                                  color:
                                    pathname === item.path
                                      ? "#1492AF"
                                      : "#50566E",
                                  marginRight: "5px",
                                }}
                              >
                                {item.icon}
                              </ListItemIcon>
                              <ListItemText
                                sx={{
                                  color:
                                    pathname === item.path
                                      ? "#1492AF"
                                      : "#050D2E",
                                  "& .MuiTypography-root": {
                                    fontWeight:
                                      pathname === item.path ? 500 : 400,
                                    opacity: pathname === item.path ? 1 : 0.85,
                                    fontSize: ".9375rem",
                                  },
                                }}
                              >
                                {item.name}
                              </ListItemText>
                            </ListItemButton>
                          </Link>
                        );
                      })}
                  </MenuList>
                </Grid>
                {mainMenu.filter((item) => item.category === "settings")
                  .length ? (
                  <Grid container direction="column" sx={{ padding: "8px" }}>
                    <Typography
                      sx={{
                        fontSize: "12px",
                        lineHeight: "14px",
                        color: "#8792AB",
                        fontWeight: 500,
                      }}
                    >
                      SETTINGS
                    </Typography>
                    <MenuList sx={{ width: "216px" }}>
                      {mainMenu
                        .filter((item) => item.category === "settings")
                        ?.map((item) => {
                          return (
                            <div key={item.id}>
                              {item.path ? (
                                <Link
                                  to={item.path}
                                  style={{
                                    textDecoration: "none",
                                    color: "#D4EDF3",
                                  }}
                                >
                                  <ListItemButton
                                    sx={{
                                      padding: "8px",
                                      maxHeight: "32px",
                                      height: "32px",
                                      width: "216px",
                                      "&:hover": { backgroundColor: "#D4EDF3" },
                                      backgroundColor:
                                        (pathname === "/license/modules" &&
                                          item.path === "/license") ||
                                        pathname === item.path
                                          ? "#D4EDF3"
                                          : "#fffff",
                                    }}
                                  >
                                    <ListItemIcon
                                      sx={{
                                        width: "20px",
                                        minWidth: "20px",
                                        height: "20px",
                                        color:
                                          (pathname === "/license/modules" &&
                                            item.path === "/license") ||
                                          pathname === item.path
                                            ? "#1492AF"
                                            : "#50566E",
                                        marginRight: "5px",
                                      }}
                                    >
                                      {item.icon}
                                    </ListItemIcon>
                                    {item.path ? (
                                      <ListItemText
                                        sx={{
                                          color:
                                            (pathname === "/license/modules" &&
                                              item.path === "/license") ||
                                            pathname === item.path
                                              ? "#1492AF"
                                              : "#050D2E",
                                          "& .MuiTypography-root": {
                                            fontWeight:
                                              (pathname ===
                                                "/license/modules" &&
                                                item.path === "/license") ||
                                              pathname === item.path
                                                ? 500
                                                : 400,

                                            opacity:
                                              (pathname ===
                                                "/license/modules" &&
                                                item.path === "/license") ||
                                              pathname === item.path
                                                ? 1
                                                : 0.85,
                                            fontSize: ".9375rem",
                                          },
                                        }}
                                      >
                                        {item.name}
                                      </ListItemText>
                                    ) : (
                                      <ListItemText
                                        sx={{
                                          color: "#050D2E",
                                          fontSize: ".9375rem",
                                          opacity: 0.85,
                                        }}
                                      >
                                        {item.name}
                                      </ListItemText>
                                    )}
                                  </ListItemButton>
                                </Link>
                              ) : (
                                <ListItemButton
                                  sx={{
                                    padding: "8px",
                                    maxHeight: "32px",
                                    height: "32px",
                                    width: "216px",
                                    "&:hover": { backgroundColor: "#D4EDF3" },
                                    backgroundColor:
                                      pathname === item.path
                                        ? "#D4EDF3"
                                        : "#fffff",
                                  }}
                                  onClick={
                                    item.id === "admin-tool"
                                      ? handleAdminToolClick
                                      : handleUserManagementClick
                                  }
                                >
                                  <ListItemIcon
                                    sx={{
                                      width: "20px",
                                      minWidth: "20px",
                                      height: "20px",
                                      color:
                                        pathname === item.path
                                          ? "#1492AF"
                                          : "#50566E",
                                      marginRight: "5px",
                                    }}
                                  >
                                    {item.icon}
                                  </ListItemIcon>

                                  <ListItemText
                                    sx={{
                                      color: "#050D2E",
                                      fontSize: ".9375rem",
                                      opacity: 0.85,
                                    }}
                                  >
                                    {item.name}
                                  </ListItemText>
                                  <KeyboardArrowRightIcon
                                    sx={{
                                      color: "#050D2E",
                                      opacity: 0.75,
                                    }}
                                  />
                                </ListItemButton>
                              )}
                            </div>
                          );
                        })}
                    </MenuList>
                    <StyledMenu
                      id="nested-menu"
                      MenuListProps={{
                        "aria-labelledby": "nested-menu",
                      }}
                      anchorEl={anchorEl}
                      open={open}
                      onClose={handleCloseNestedMenu}
                    >
                      {nestedMenu?.map((item) => {
                        return (
                          <div key={item.id}>
                            <Link
                              to={item.path}
                              style={{ textDecoration: "none" }}
                            >
                              <MenuItem
                                disableRipple
                                onClick={handleCloseNestedMenu}
                              >
                                {item.name}
                              </MenuItem>
                            </Link>
                          </div>
                        );
                      })}
                    </StyledMenu>
                  </Grid>
                ) : null}
              </>
            ) : (
              <>
                {menuTitle ? (
                  <Grid container sx={{ padding: "16px" }}>
                    <Grid item>
                      <Link to="/" style={{ textDecoration: "none" }}>
                        <KeyboardArrowLeftIcon fontSize="medium" />
                      </Link>
                    </Grid>
                    <Grid item>
                      <Typography sx={{ color: "#050D2E", fontWeight: 500 }}>
                        {menuTitle}
                      </Typography>
                    </Grid>
                  </Grid>
                ) : null}

                <MenuList sx={{ width: "200px", padding: "8px" }}>
                  {mainMenu.map((item) => {
                    return (
                      <Link
                        key={item.id}
                        to={item.path}
                        style={{ textDecoration: "none", color: "#D4EDF3" }}
                      >
                        <ListItemButton
                          sx={{
                            padding: "8px",
                            maxHeight: "32px",
                            height: "32px",
                            width: "216px",
                            marginBottom: "5px",

                            "&:hover": { backgroundColor: "#D4EDF3" },
                            backgroundColor:
                              pathname === item.path ? "#D4EDF3" : "#fffff",
                          }}
                        >
                          {/*     <ListItemIcon
                            sx={{
                              width: "20px",
                              minWidth: "20px",
                              height: "20px",
                              color:
                                pathname === item.path ? "#1492AF" : "#50566E",
                              marginRight: "5px",
                            }}
                          >
                            {item.icon}
                          </ListItemIcon> */}
                          <ListItemText
                            sx={{
                              color:
                                pathname === item.path ? "#1492AF" : "#050D2E",
                              "& .MuiTypography-root": {
                                fontWeight: pathname === item.path ? 500 : 400,
                                fontSize: ".9375rem",
                                opacity: 0.85,
                                lineHeight: "1.1",
                              },
                            }}
                          >
                            {item.name}
                          </ListItemText>
                        </ListItemButton>
                      </Link>
                    );
                  })}
                </MenuList>
              </>
            )}

            {/* : AlertsRoutes.includes(pathname) ? (
              <>
                <Grid container sx={{ padding: "16px" }}>
                  <Grid item>
                    <Link to="/" style={{ textDecoration: "none" }}>
                      <KeyboardArrowLeftIcon fontSize="medium" />
                    </Link>
                  </Grid>
                  <Grid item>
                    <Typography sx={{ color: "#050D2E", fontWeight: "600" }}>
                      Alerts&Notifications
                    </Typography>
                  </Grid>
                </Grid>
                <MenuList sx={{ width: "200px", padding: "8px" }}>
                  {AlertsMenu.map((item) => {
                    return (
                      <Link
                        key={item.id}
                        to={item.path}
                        style={{ textDecoration: "none", color: "#D4EDF3" }}
                      >
                        <ListItemButton
                          sx={{
                            padding: "8px",
                            maxHeight: "32px",
                            height: "32px",
                            width: "216px",
                            "&:hover": { backgroundColor: "#D4EDF3" },
                            backgroundColor:
                              pathname === item.path ? "#D4EDF3" : "#fffff",
                          }}
                        >
                          <ListItemText
                            sx={{
                              color:
                                pathname === item.path ? "#1492AF" : "#050D2E",
                              "& .MuiTypography-root": {
                                fontWeight:
                                  pathname === item.path ? "550" : "400",
                                fontSize: "14px",
                              },
                            }}
                          >
                            {item.name}
                          </ListItemText>
                        </ListItemButton>
                      </Link>
                    );
                  })}
                </MenuList>
              </>
            ) : MatchingRoutes.includes(pathname) ? (
              <>
                <Grid container sx={{ padding: "16px" }}>
                  <Grid item>
                    <Link to="/" style={{ textDecoration: "none" }}>
                      <KeyboardArrowLeftIcon fontSize="medium" />
                    </Link>
                  </Grid>
                  <Grid item>
                    <Typography sx={{ color: "#050D2E", fontWeight: "600" }}>
                      Matching
                    </Typography>
                  </Grid>
                </Grid>
                <MenuList sx={{ width: "200px", padding: "8px" }}>
                  {MatchingMenu.map((item) => {
                    return (
                      <Link
                        key={item.id}
                        to={item.path}
                        style={{ textDecoration: "none", color: "#D4EDF3" }}
                      >
                        <ListItemButton
                          sx={{
                            padding: "8px",
                            maxHeight: "32px",
                            height: "32px",
                            width: "216px",
                            "&:hover": { backgroundColor: "#D4EDF3" },
                            backgroundColor:
                              pathname === item.path ? "#D4EDF3" : "#fffff",
                          }}
                        >
                          <ListItemText
                            sx={{
                              color:
                                pathname === item.path ? "#1492AF" : "#050D2E",
                              "& .MuiTypography-root": {
                                fontWeight:
                                  pathname === item.path ? "550" : "400",
                              },
                            }}
                          >
                            {item.name}
                          </ListItemText>
                        </ListItemButton>
                      </Link>
                    );
                  })}
                </MenuList>
              </>
            ): UserManagementRoutes.includes(pathname) ? (
              <>
                <Grid container sx={{ padding: "16px" }}>
                  <Grid item>
                    <Link to="/" style={{ textDecoration: "none" }}>
                      <KeyboardArrowLeftIcon fontSize="medium" />
                    </Link>
                  </Grid>
                  <Grid item>
                    <Typography sx={{ color: "#050D2E", fontWeight: "600" }}>
                      User Management
                    </Typography>
                  </Grid>
                </Grid>
                <MenuList sx={{ width: "200px", padding: "8px" }}>
                  {UserManagementMenu.map((item) => {
                    return (
                      <Link
                        key={item.id}
                        to={item.path}
                        style={{ textDecoration: "none", color: "#D4EDF3" }}
                      >
                        <ListItemButton
                          sx={{
                            padding: "8px",
                            maxHeight: "32px",
                            height: "32px",
                            width: "216px",
                            "&:hover": { backgroundColor: "#D4EDF3" },
                            backgroundColor:
                              pathname === item.path ? "#D4EDF3" : "#fffff",
                          }}
                        >
                          <ListItemText
                            sx={{
                              color:
                                pathname === item.path ? "#1492AF" : "#050D2E",
                              "& .MuiTypography-root": {
                                fontWeight:
                                  pathname === item.path ? "550" : "400",
                              },
                            }}
                          >
                            {item.name}
                          </ListItemText>
                        </ListItemButton>
                      </Link>
                    );
                  })}
                </MenuList>
              </>
            ) */}

            <ClickAwayListener onClickAway={() => setSettingsDrawerOpen(false)}>
              <Grid
                container
                justifyContent="space-between"
                alignItems="center"
                sx={{
                  position: "absolute",
                  bottom: "0px",
                  left: "0px",
                  borderTop: "solid",
                  borderTopColor: "#E7E9EF",
                  borderTopWidth: "thin",
                  cursor: "pointer",
                }}
                onClick={() => setSettingsDrawerOpen(true)}
              >
                <Grid item sx={{ padding: "16px" }}>
                  <Typography
                    sx={{
                      color: "#050D2E",
                      fontSize: ".938rem",
                      opacity: 0.75,
                      lineHeight: "17px",
                      fontWeight: 500,
                    }}
                  >
                    {!keycloak.hasRealmRole("super-admin")
                      ? keycloak.tokenParsed.bankName
                      : "eVision"}
                  </Typography>
                  <Typography
                    sx={{
                      color: "#50566E",
                      fontSize: ".813rem",
                      opacity: ".75",
                      lineHeight: "14px",
                      marginTop: "3px",
                    }}
                  >
                    {!keycloak.hasRealmRole("super-admin")
                      ? keycloak.tokenParsed.BIC
                      : "eVision"}
                  </Typography>
                </Grid>
                <Grid item sx={{ padding: "22px" }}>
                  <KeyboardArrowUpIcon />
                </Grid>
              </Grid>
            </ClickAwayListener>
            <Drawer
              anchor="bottom"
              sx={{
                display: { xs: "none", sm: "block" },
                "& .MuiDrawer-paper": {
                  boxSizing: "border-box",
                  width: "220px",
                  margin: "10px",
                  background: "#FFFFFF",
                  minHeight: `180px`,
                  position: "absolute",
                  bottom: "30px",
                  borderRadius: "5px",
                  paddingY: "15px",
                },
              }}
              onClose={toggleSettingsDrawer}
              open={settingsDrawerOpen}
              hideBackdrop={true}
              transitionDuration={500}
              variant="temporary"
            >
              <Grid
                container
                spacing={1}
                alignItems="center"
                sx={{ padding: "15px" }}
              >
                <Grid item>
                  <RandomlyColoredAvatar
                    name={`${keycloak.tokenParsed.name}`}
                  />
                </Grid>
                <Grid item>
                  <Typography
                    sx={{
                      color: "#050D2E",
                      fontSize: "1.125rem",
                      fontWeight: 500,
                      letterSpacing: "-0.6px",
                      lineHeight: "20px",
                    }}
                  >
                    {keycloak.tokenParsed.name}
                  </Typography>
                  <Typography
                    sx={{
                      marginTop: "3px",
                      color: "#8792AB",
                      fontSize: ".875rem",
                      fontWeight: 500,
                      letterSpacing: "-0.47px",
                      lineHeight: "16px",
                    }}
                  >
                    {!keycloak.hasRealmRole("super-admin")
                      ? keycloak.tokenParsed.bankName
                      : "eVision"}
                  </Typography>
                </Grid>
              </Grid>
              <Divider sx={{ marginTop: "10px", marginBottom: "20px" }} />
              <Grid
                container
                justifyContent="start"
                alignItems="center"
                spacing={1}
                sx={{
                  paddingLeft: "20px",
                  marginBottom: "10px",
                  cursor: "pointer",
                  "&:hover": { backgroundColor: "#D4EDF3" },
                }}
              >
                <Grid item>
                  <AccountBoxIcon fontSize="small" color="#50566E" />
                </Grid>
                <Grid item>
                  <Typography
                    sx={{
                      opacity: 0.75,
                      color: "#050D2E",
                      fontSize: ".938rem",
                      letterSpacing: 0,
                      lineHeight: "17px",
                    }}
                  >
                    Account Settings
                  </Typography>
                </Grid>
              </Grid>
              <Grid
                container
                justifyContent="start"
                alignItems="center"
                spacing={1}
                sx={{
                  paddingLeft: "20px",
                  cursor: "pointer",
                  "&:hover": { backgroundColor: "#D4EDF3" },
                }}
                onClick={() =>
                  keycloak.hasRealmRole("super-admin")
                    ? keycloak.logout()
                    : logoutHandler(
                        keycloak.logout,
                        keycloak.tokenParsed["license-key"]
                      )
                }
              >
                <Grid item>
                  <LogoutIcon fontSize="small" color="#50566E" />
                </Grid>
                <Grid item>
                  <Typography
                    sx={{
                      opacity: 0.75,
                      color: "#050D2E",
                      fontSize: ".938rem",
                      letterSpacing: 0,
                      lineHeight: "17px",
                    }}
                  >
                    Sign out
                  </Typography>
                </Grid>
              </Grid>
            </Drawer>
          </>
        ) : null}
      </Drawer>
    </>
  );
};

export default SideMenu;
